import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { BaseModalParams } from '../interfaces/base-modal-params.model';
import { BaseModalComponent } from '../components/modal/base-modal.component';

@Injectable({ providedIn: 'root' })
export class BaseModalService {
  constructor(private ngbModalService: NgbModal) {}

  open(modalParams: BaseModalParams, options?: NgbModalOptions): NgbModalRef {
    //Fix for "Blocked aria-hidden on an element because its descendant retained focus"
    const activeElement = document.activeElement as HTMLElement;
    if (activeElement) {
      activeElement.blur();
    }

    const defaultOptions = { centered: true, keyboard: false };
    const modalOptions = { ...defaultOptions, ...options };
    const modalRef = this.ngbModalService.open(BaseModalComponent, modalOptions);

    modalRef.componentInstance.modalData = modalParams;
    modalRef.componentInstance.content = modalParams.bodyTemplate ? modalParams.bodyTemplate : null;

    return modalRef;
  }

  closeAllModals(): void {
    const hasOpenModals = this.ngbModalService.hasOpenModals();
    if (hasOpenModals) {
      this.ngbModalService.dismissAll();
    }
  }
}
